var swiper = new Swiper(".swiper-section__swiper", {
  slidesPerView: 1.2,
  spaceBetween: 16,
  watchOverflow: true,
  breakpoints: {
    400: {
      slidesPerView: 1.2,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 2.2,
      spaceBetween: 16,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 16,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  }
});
